export class PasswordUpdateModel {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}
